import Skeleton from 'react-loading-skeleton';

interface Props {
  count?: number;
}

export const OrderSkeleton = ({ count = 1 }: Props) => {
  return (
    <div className="mt-20 px-16 py-24 md:ml-24 md:px-24 lg:ml-44 lg:px-44">
      <div className="relative w-full border-b border-neutral-300 pb-24">
        <Skeleton className="h-32 w-150"></Skeleton>
        <Skeleton className="mt-32 h-16 w-full md:w-[50%]"></Skeleton>
        <Skeleton className="mt-32 h-24 w-[60%]"></Skeleton>
      </div>

      <div className="mt-24 flex w-full flex-col gap-24">
        {new Array(count).fill(0).map((_, idx) => (
          <div key={idx} className="rounded-md border-[1.5px] border-neutral-300">
            <div className="bg-neutral-150 p-12 md:p-16 lg:px-24 lg:py-32">
              <div className="flex flex-col gap-16">
                <div className="relative w-250">
                  <Skeleton className="h-24" />
                </div>
                <div className="relative w-100">
                  <Skeleton />
                </div>
              </div>
            </div>
            <div className="flex justify-between px-12 py-16 md:px-16 lg:px-24 lg:py-20">
              <div className="relative w-100">
                <Skeleton />
              </div>
              <div className="relative w-50">
                <Skeleton />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderSkeleton;
